import { Component, Input, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { FormsService } from '../../services/forms.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { EditfolderforFormComponent } from 'src/app/middleware/common/editfolderforForm/editfolderforForm.component';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { AssociateContactRoleFormComponent } from '../associate-contact-role-form/associate-contact-role.component';
import { SimpleChanges } from '@angular/core';
import { AssociateContactRoleFormListComponent } from '../associate-contact-role-list/associate-contact-role-list.component';
import { ModuleName } from '../../services/form.enum';

@Component({
  selector: 'app-doc-detail',
  templateUrl: './doc-detail.component.html',
  styleUrls: ['./doc-detail.component.scss']
})

export class DocDetailComponent implements OnInit {
  @Input() folderetails :any=[]=[];
  @Input() typeId :any;
  
  isAddTouchVisible:boolean=false;
  modulename:string="Forms";
  addNote:boolean = false;
  isAddContactRoleShow:boolean=false;
  databaseId: string;
  organizationId: string;
  currentUser: any;
  allFormFolderTouchesList: any;
  responseHolder: any;
  selectedRecordDeleteArray: any = [];
  showAddContact: boolean;
  searchName: string;
  clickEventsubscription: any;
  clickEventsubscriptionform: any;
  formFolderIDSendToAPI: any;
  formIDSendToAPI: any;
  mainModuleName: string;
  SharedContactRoleCount:number;
  OfficeIDList: any=[];
  myOfficeID: any;
  isSharedWithMeForm:string="";
  isShared:any;
  
  constructor(private dialog: MatDialog, private formsService:FormsService,  
    private encryptionAlgo: EncryptionService,private statusConstant: StatusConstant,
    private reusableClass: ReusableClasses,  private toastr: ToastrService,
    private _dataSharingService: DataSharingService,private cdr: ChangeDetectorRef) { 

    this.modulename='Forms';
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
  

     var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if (Module.length > 0) {
      this.modulenameContact = Module[0].orgModuleName;
    }

    if(this.folderetails!=undefined && this.folderetails!='') {
      this.typeId; // 1 for Folder , 2 for Form
      this.isSharedWithMeForm =sessionStorage.getItem('isSharedWithMeForm');
      this.isShared =sessionStorage.getItem('isShared');
      if(this.typeId == 1){
       // this.GetAllFormTouches(0);
        this.getSharedContactRoleList(this.folderetails);
      }
      if(this.typeId == 2){
        //this.GetAllFormTouches(0);        
        this.getSharedContactRoleList(this.folderetails);
      }
    }
   }

  
  ngOnInit(): void {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if (Module.length > 0) {
      this.modulenameContact = Module[0].orgModuleName;
    }
   
    if(this.folderetails!=undefined && this.folderetails!='') {
      this.GetAllFormTouches(0);      
    }   

    this.clickEventsubscriptionform = this._dataSharingService.getCurrentFormContactdashBoard().subscribe((result) => {
      if(result!='' && result!=undefined) {
        this.addContactOrRole(result.id,result.isFolder)
      }
    });

    this.clickEventsubscription = this._dataSharingService.getRefreshDetailsSharedRoleListForForm().subscribe((result) => {
      if(result) {         
        this.getSharedContactRoleList(this.folderetails);   
      }
    });    
  }
  
  onTabClick(event) {
    if(event.tab.textLabel=="Notes" || event.index==1){
      this.allFormFolderTouchesList=[];
      this.GetAllFormTouches(0);  
    }    
  }

  getSharedContactRoleList(folderetails) {
    // 1 for Folder , 2 for Form
    if(this.typeId == 1){
      var itemID =folderetails.formFolderID;
     }
     if(this.typeId == 2){
      var itemID =folderetails.formID;
     }
     var ReqModel={
       nameFieldID:0,
       emailFieldID:0,
       databaseID:Number(this.databaseId),
       organizationID:Number(this.organizationId),   
       itemID:itemID,//folderetails.formFolderID,
       itemType:this.typeId,//1,
       pageIndex:0,
       pageSize:0,
       userID:this.currentUser.UID    
     }
    this.formsService.GetAllFormSharedTo(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {        
          this.SharedContactRoleCount = this.responseHolder.data.formSharedToList.length;
        }
      } else {
      }
    });
  }


  // async getSharedContactRoleList(folderetails) {
  //   // 1 for Folder , 2 for Form
  //   if(this.typeId == 1){
  //    var itemID =folderetails.formFolderID;
  //   }
  //   if(this.typeId == 2){
  //    var itemID =folderetails.formID;
  //   }
  //   var ReqModel={
  //     nameFieldID:0,
  //     emailFieldID:0,
  //     databaseID:Number(this.databaseId),
  //     organizationID:Number(this.organizationId),   
  //     itemID:itemID,//folderetails.formFolderID,
  //     itemType:this.typeId,//1,
  //     pageIndex:0,
  //     pageSize:0,
  //     userID:this.currentUser.UID    
  //   }
  //   const result = await this.formsService.GetAllFormSharedTo(ReqModel).toPromise();
  //   if (result.status === this.statusConstant.statusSuccess) {    
  //     this.responseHolder = result.data.formSharedToList;
  //     if(this.responseHolder !=null){
  //       this.SharedContactRoleCount =this.responseHolder.length;            
  //     }          
  //   }
  //   else {      
  //   } 
  // }

  
  async GetAllFormTouches(touchesTypeID) {
     // 1 for Folder , 2 for Form
    if(this.typeId ==1){
    var formFolderID =this.folderetails.formFolderID;
    }
    if(this.typeId ==2){
      var formFolderID =this.folderetails.formID;
    }
    var ReqModel={
      folderID:this.typeId,
      documentID:Number(this.folderetails.formID),
      transactionID:Number(this.folderetails.formFolderID),
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      touchesType:(touchesTypeID==undefined || touchesTypeID=='')?0:touchesTypeID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
    }    
    const result = await this.formsService.GetAllFormTouches(ReqModel).toPromise();
    if (result.status === this.statusConstant.statusSuccess) {    
      this.allFormFolderTouchesList=result.data==null?[]:result.data;
      if(this.allFormFolderTouchesList !=null){
        this.allFormFolderTouchesList.map((res) => {
          if (res.createdByLastName != null) {
            res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByFirstName);
          }
          if (res.createdByLastName != null) {
            res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
          }             
          return res;
        });  
      }          
    }
    else {     
    } 
  }


  RenameFolders(form) {
    // 1 for Folder , 2 for Form
    if(this.typeId == 1){
     var formFolderName = form.formFolderName;
     var  formFolderID = form.formFolderID;
    }
    if(this.typeId == 2){
     var formFolderName = form.formName;
     var formFolderID  = form.formID;
     }
    const dialogRef = this.dialog.open(EditfolderforFormComponent, {     
      data: {       
         formFolderName:formFolderName,
         formFolderID: formFolderID,
         parentID:0,//form.parentID,
         type:this.typeId  //1-For Folder , 2-For Form
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result != undefined){
        if(this.typeId ==1){ //1-For Folder , 2-For Form
          this.getFormFolderDetail(form);
        }
        if(this.typeId ==2){ //1-For Folder , 2-For Form
          this.getFormDetail(form);
        }
       this._dataSharingService.sendRefreshListForForm(true);  
      }
    });
  }


  DeleteFolders(form) {
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) { 
        this.selectedRecordDeleteArray=[];
        //{ 1- Folder, 2- Form}
        if(this.typeId == 1){
          var formFolderID = form.formFolderID;
        }
        if(this.typeId == 2){
          var formFolderID = form.formID;
        }
        let request = {
          id: formFolderID,//form.formFolderID,  // FolderID  |  FormID
          itemType: this.typeId   //{ 1- Folder, 2- Form}        
        };

       this.selectedRecordDeleteArray.push(request);        

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
       }
        this.formsService.DeleteFormItems(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {              
              if(this.typeId ==1){ //1-For Folder , 2-For Form
                this.getFormFolderDetail(form.parentID);
                this.toastr.success('Folder deleted successfully.', '', {
                  timeOut: 3000,
                });
              }
              if(this.typeId ==2){ //1-For Folder , 2-For Form
                this.getFormDetail(form.parentID);
                this.toastr.success('Form deleted successfully.', '', {
                  timeOut: 3000,
                });
              }
              
              this._dataSharingService.sendRefreshListForForm(true);
              this.selectedRecordDeleteArray=[];           
            }
          }
        });
      }
    });
}  

  getFormFolderDetail(form) {
    var formFolderID = form.formFolderID;
    if(formFolderID != undefined){
       formFolderID = form.formFolderID;
    }
    else{
      formFolderID = form;
    }
    var ReqModel ={      
      id:formFolderID,//form.formFolderID,     
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID:Number(this.databaseId),
    }
    this.formsService.GetFormFolderDetail(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) { 
          this.folderetails=[];     
          this.folderetails = this.responseHolder.data;
          if (this.folderetails.createdByLastName != null) {
            this.folderetails.createdByFirstName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.createdByFirstName);
          }
          if (this.folderetails.createdByLastName != null) {
            this.folderetails.createdByLastName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.createdByLastName);
          }
          if (this.folderetails.updatedByFirstName != null) {
            this.folderetails.updatedByFirstName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.updatedByFirstName);
          }
          if (this.folderetails.updatedByLastName != null) {
            this.folderetails.updatedByLastName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.updatedByLastName);
          }        
        }
        else {        
        }
      }
      else {      
      }
    });
  }


  getFormDetail(form) {
    var formFolderID = form.formID;
    if(formFolderID != undefined){
       formFolderID = form.formID;
    }
    else{
      formFolderID = form;
    }
    var ReqModel ={      
      id:formFolderID,//form.formFolderID,     
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
    }
    this.formsService.GetFormDetail(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) { 
          this.folderetails=[];     
          this.folderetails = this.responseHolder.data;   
          if (this.folderetails.createdByLastName != null) {
            this.folderetails.createdByFirstName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.createdByFirstName);
          }
          if (this.folderetails.createdByLastName != null) {
            this.folderetails.createdByLastName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.createdByLastName);
          }  

          if (this.folderetails.updatedByFirstName != null) {
            this.folderetails.updatedByFirstName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.updatedByFirstName);
          }
          if (this.folderetails.updatedByLastName != null) {
            this.folderetails.updatedByLastName = this.encryptionAlgo.get(
              this.reusableClass.decryptionKey,this.folderetails.updatedByLastName);
          }         
        }
        else {        
        }
      }
      else {      
      }
    });
  }

  addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {       
        moduleName:'Forms',
        formFolderID:this.folderetails.formFolderID,
        formID:this.folderetails.formID,
        typeId: this.typeId
      },
       panelClass: 'autoFill-modalbox'  
    });
    dialogRef.afterClosed().subscribe(result => { 
      if(result!=null && result!=undefined){
        this.GetAllFormTouches(0);
      }         
    });   
  }

  modulenameContact:string="";

  addContactOrRole(folderetails,IsFolder) {
    //this.formFolderIDSendToAPI=IsFolder==true?folderetails.Id:0;
    //this.formIDSendToAPI=IsFolder==true?0:folderetails.Id;
    //this.mainModuleName=IsFolder==true?'FormFolder':'Form';
    //1-For Folder , 2-For Form
   
    if(this.typeId==1){
      this.mainModuleName="FormFolder";
      this.formFolderIDSendToAPI=folderetails.formFolderID; //=IsFolder==true?folderetails.Id:0;
    }
    if(this.typeId==2){
      this.mainModuleName="Form";
      this.formIDSendToAPI=folderetails.formID;//IsFolder==true?0:folderetails.Id;
    }
    const dialogRef = this.dialog.open(AssociateContactRoleFormComponent, { 
      id: 'addContactOrRoleDialog',    
      panelClass: 'custom-modalbox',
      data: {
        moduleName:'Forms',
        formFolderID:folderetails.formFolderID,//IsFolder==true?folderetails.Id:0,
        formID:folderetails.formID,//IsFolder==true?0:folderetails.formID,
        typeId:this.typeId
      }
    });
    dialogRef.afterClosed().subscribe(result => {  
      if(result!=null && result!=undefined){
       
      }
    });
  }

  showSharedContactRoleList() {
    const dialogRef = this.dialog.open(AssociateContactRoleFormListComponent, { 
      id: 'addContactOrRoleDialog',   
      panelClass: 'custom-modalbox', 
      data: {
        moduleName:'Forms',
        formFolderID:this.folderetails.formFolderID,
        formID:this.folderetails.formID,
        typeId: this.typeId
      }
    });
    dialogRef.afterClosed().subscribe(result => {  
     if(result!=null && result!=undefined){
       
     }
    });  
  }

  showAddtouch() {
    this.isAddTouchVisible=true;
  }

 
  addNewNote() {
    this.addNote = !this.addNote
  }

  addShare(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  close() {
    this.dialog.closeAll();
  }


  fileAccess(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    })
  }

  peoples = [
    {
      name: 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',
    },
    {
      name: 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',
    },
    {
      name: 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',
    },
    {
      name: 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',
    },
    {
      name: 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',
    },


  ]

}
